import React from 'react';
import { getPostedDateParts } from '../utils/dateUtils';

interface PostedDateProps { dateString: string; now?: Date; }

const PostedDate: React.FC<PostedDateProps> = ({ dateString, now }) => {
  const { formattedDate, relativePart, isOlderThanFourteenDays } = getPostedDateParts(dateString, now);
  return <span>Posted {formattedDate}{relativePart && <> <span className={isOlderThanFourteenDays ? 'font-semibold text-red-600' : undefined}>{relativePart}</span></>}</span>;
};

export default PostedDate;
